import React, { createContext, useState } from 'react';
import noop from 'lodash/noop';

interface Props {
  children: React.ReactNode;
}

interface Context {
  touchedList: string[];
  addNewTouchedField: (a: string) => void;
}

const FormTextFieldContext = createContext<Context>({
  touchedList: [],
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  addNewTouchedField: (a: string) => noop(),
});

function FormTextFieldProvider(props: Props) {
  const [touchedList, setTouched] = useState<string[]>([]);

  const addNewTouchedField = (newField: string): void => {
    setTouched([...touchedList, newField]);
  };

  const context: Context = {
    touchedList,
    addNewTouchedField,
  };

  return <FormTextFieldContext.Provider value={context}>{props.children}</FormTextFieldContext.Provider>;
}

export { FormTextFieldContext, FormTextFieldProvider };
